export default {
  markers: [],
  visible: [],
  selected: null,
};
